import Vue from 'vue'
import routerPageHook from '@assets/js/routerPageHook.js'
import PageForm from '@shared/ui/public/forms/PageForm.vue'
import VideoBlock from '@components/ui-components/video-block/component.js'
import titleLink from '@components/ui-components/title-link/component.js'

export default {
  name: 'index',
  data() {
    return {
      template: '<main></main>',
    }
  },
  components: {
    'page-form-cmp': PageForm,
    'video-block-cmp': VideoBlock,
    'title-link-cmp': titleLink,
  },
  methods: {},
  ...routerPageHook,
  render(createElement) {
    return Vue.compile(this.template).render.call(this, createElement)
  },
}



// WEBPACK FOOTER //
// ./src/templates/pages/team/index.js